import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, Upload, Icon, notification, Row, Col, Typography, InputNumber, Carousel } from 'antd';
import ApiCaller from '../../../utils/api-caller';
import Toast from 'antd-mobile/lib/toast';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Markup } from 'interweave';
import './DevaranaUpdate.css';

const { TextArea } = Input;
const { Text, Paragraph } = Typography;

@inject(
    'CmsLanguageStore',
    'CmsDevaranaStore'
)
@observer
class DevaranaUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
    }

    create = () => {
        this.props.CmsDevaranaStore.create().then(() => {
            this.props.CmsDevaranaStore.setupdateLoading(false);
            this.props.CmsDevaranaStore.setshowModal(false);
            this.props.CmsDevaranaStore.getAll();
        });
    }

    update = () => {
        this.props.CmsDevaranaStore.update().then(() => {
            this.props.CmsDevaranaStore.setupdateLoading(false);
            this.props.CmsDevaranaStore.setshowModal(false);
            this.props.CmsDevaranaStore.getAll();
        });
    }

    cancel = () => {
        this.props.CmsDevaranaStore.setshowModal(false);
    }

    // UPLOAD Settings

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file, id) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'You can only upload JPG/PNG file!',
                placement: 'bottomRight',
            })
        }

        const isLessThan10Mb = file.size / 1024 / 1024 < 2;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller than 2MB!',
                placement: 'bottomRight',
            })
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.props.CmsDevaranaStore.setImageIsLoadingById(id, true);
        }

        return isJpgOrPng && isLessThan10Mb
    }

    uploadChange = (info, id, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.CmsDevaranaStore.setImageUrlById(id, '')
                return
            }
            if (info.file.status === 'done') {
                const category = 'Devarana'
                const titleName = title || 'Default'

                return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.CmsDevaranaStore.setImageUrlById(id, response.imageUrl)
                    this.props.CmsDevaranaStore.setImageIsLoadingById(id, false);
                })
            }
        }
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            devarana,
            updateLoading,
            images
        } = this.props.CmsDevaranaStore;

        let hasError = true;

        const defaultLang = devarana.devaranaLanguages.find(fi => fi.languageId === 1);
        if (defaultLang) {
            hasError = images.length === 0 || defaultLang.title === '' || defaultLang.briefDescription === '' || defaultLang.description === '';
        }

        if (updateLoading) {
            Toast.loading('Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            {
                                devarana
                                    ?
                                    <>
                                        <Form layout='vertical'>

                                            {/* Title */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Title</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                devarana.devaranaLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <TextArea
                                                                                                        rows={2}
                                                                                                        value={devarana.devaranaLanguages.find(fi => fi.languageId === lang.id).title}
                                                                                                        onChange={(e) => this.props.CmsDevaranaStore.settitle(lang.id, e.target.value)}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Brief Description */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Brief Description</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                devarana.devaranaLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <TextArea
                                                                                                        rows={3}
                                                                                                        value={devarana.devaranaLanguages.find(fi => fi.languageId === lang.id).briefDescription}
                                                                                                        onChange={(e) => this.props.CmsDevaranaStore.setbriefDescription(lang.id, e.target.value)}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Description */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Description</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                devarana.devaranaLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <CKEditor
                                                                                                        editor={ClassicEditor}
                                                                                                        data={devarana.devaranaLanguages.find(fi => fi.languageId === lang.id).description}
                                                                                                        onChange={(event, editor) => {
                                                                                                            const data = editor.getData();
                                                                                                            this.props.CmsDevaranaStore.setdescription(lang.id, data)
                                                                                                        }}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>

                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Sort */}
                                            <>
                                                <Form.Item label='Sort'>
                                                    <InputNumber
                                                        className='stm-width-100'
                                                        value={devarana.sort}
                                                        onChange={(value) => this.props.CmsDevaranaStore.setsort(value)}
                                                        min={1}
                                                    />
                                                </Form.Item>
                                            </>

                                            {/* Banner */}
                                            <>
                                                {
                                                    images.map(image => {
                                                        return (
                                                            <Form.Item key={image.id} label={
                                                                image.url === ''
                                                                    ?
                                                                    'Create Banner (Minimum resolution: 640x480)'
                                                                    :
                                                                    <>
                                                                        <Row className='updatedevarana-row-label'>
                                                                            <Col span={12} className='updatedevarana-col-label'>Update Banner (Minimum resolution: 640x480)</Col>
                                                                            <Col span={12} className='updatedevarana-col-label-button'>
                                                                                <Button type='danger' onClick={() => this.props.CmsDevaranaStore.removeImageById(image.id)}>Delete</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                            }>
                                                                <Upload
                                                                    listType='picture-card'
                                                                    className='avatar-uploader'
                                                                    showUploadList={false}
                                                                    customRequest={this.dummyRequest}
                                                                    beforeUpload={(info) => this.beforeUpload(info, image.id)}
                                                                    onChange={(info) => this.uploadChange(info, image.id, 'Devarana')}
                                                                >
                                                                    {
                                                                        image.url !== ''
                                                                            ?
                                                                            <img src={image.url} alt='avatar' className='updatedevarana-img' />
                                                                            :
                                                                            <div>
                                                                                <Icon type={image.isLoading ? 'loading' : 'plus'} />
                                                                                <div className='ant-upload-text'>Upload</div>
                                                                            </div>}
                                                                </Upload>
                                                            </Form.Item>
                                                        )
                                                    })
                                                }
                                            </>

                                            {/* Preview */}
                                            <>
                                                <Form.Item label='Preview Banner'>
                                                    <Row>
                                                        <Col span={24} className='updatedevarana-col-preview-container'>
                                                            {
                                                                images.length === 1
                                                                    ?
                                                                    null
                                                                    :
                                                                    <Row>
                                                                        <Col className='updatedevarana-col-preview-img'>
                                                                            <Row>
                                                                                <Col
                                                                                    span={24}
                                                                                    className={images.length === 2 ? 'updatedevarana-col-carousel-container-single' : 'updatedevarana-col-carousel-container'}
                                                                                >
                                                                                    <Carousel>
                                                                                        {
                                                                                            images.filter(fi => fi.url !== '').map(image => {
                                                                                                return (
                                                                                                    <div key={image.id} className='updatedevarana-div-carousel'>
                                                                                                        <Row className='updatedevarana-row-carousel'>
                                                                                                            <Col span={24} className='updatedevarana-col-carousel'>
                                                                                                                <img className='updatedevarana-img-carousel' src={image.url} alt={image.id} />
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </Carousel>
                                                                                </Col>
                                                                            </Row>
                                                                            <>
                                                                                {
                                                                                    devarana.devaranaLanguages.find(fi => fi.languageId === 1)
                                                                                        ?
                                                                                        <>
                                                                                            <Row className='updatedevarana-row-detail'>
                                                                                                <Col span={24} className='updatedevarana-col-preview-title'>
                                                                                                    <Text className='updatedevarana-text-preview-title'>{devarana.devaranaLanguages.find(fi => fi.languageId === 1).title}</Text>
                                                                                                </Col>
                                                                                                <Paragraph className='clr-theme-dark-1'>
                                                                                                    <Markup content={devarana.devaranaLanguages.find(fi => fi.languageId === 1).description} />
                                                                                                </Paragraph>
                                                                                            </Row>
                                                                                        </>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </>

                                                                        </Col>
                                                                    </Row>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Form.Item>
                                            </>

                                            {/* Button */}
                                            <>
                                                <Form.Item>
                                                    {
                                                        devarana.id === 0
                                                            ?
                                                            <Button onClick={this.create} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Create</Button>
                                                            :
                                                            <Button onClick={this.update} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Update</Button>
                                                    }

                                                    <Button onClick={this.cancel}>Cancel</Button>
                                                </Form.Item>
                                            </>
                                        </Form>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default DevaranaUpdate;